import { Component, OnInit } from '@angular/core';
import {
  Route,
  Router,
  ActivatedRoute
} from '@angular/router';
import { Validator } from '../../../validator';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/services/auth.service';
import { DbService } from 'src/app/services/db.service';
import { take } from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loadPage = document.getElementById('load');

  public loading = true;
  public form: FormGroup;
  public loginErr = true;
  public exitUser = true;
  public loginInfo = {
    id: '',
    password: '',
  };
  public student;
  public teacher;
  public whatType = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    private dbService: DbService,
    private spinner: NgxSpinnerService,
    public formBuilder: FormBuilder,
  ) {
    this.form = formBuilder.group({
      id: Validator.idValidator,
      password: Validator.passwordValidator
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.loading = false;
    }, 2500);
  }


  async loginCheck() {
    this.spinner.show();
    const credentials = {
      email: `${this.form.controls.id.value}@gmail.com`,
      password: this.form.controls.password.value
    };

    await this.authService.loginUser(credentials).then(async (success) => {
      this.student = this.dbService.doc$(`student/${success.user.uid}`);
      this.teacher = this.dbService.doc$(`teacher/${success.user.uid}`);
      await this.student.pipe(take(1)).subscribe((data) => {
        if (data.exitSwitch) {
          this.authService.logoutUser();
          localStorage.clear();
          this.exitUser = false;
          this.loginInfo.id = '';
          this.loginInfo.password = '';
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.router.navigate(['/']);
        }
      });
      await this.teacher.pipe(take(1)).subscribe((data) => {
        if (data.exitSwitch) {
          this.authService.logoutUser();
          localStorage.clear();
          this.exitUser = false;
          this.loginInfo.id = ''
          this.loginInfo.password = ''
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.router.navigate(['/']);
        }
      });
      // this.spinner.hide();
      // this.router.navigate(['/']);
    }).catch(error => {
      this.loginErr = false;
      this.spinner.hide();
      console.log('Error', error);
    });
  }

  signup(): any {
    this.router.navigate(['/login-signup']);
  }




}
